import { render, staticRenderFns } from "./schoolyearSelect.vue?vue&type=template&id=305cb4dc&"
import script from "./schoolyearSelect.vue?vue&type=script&lang=js&"
export * from "./schoolyearSelect.vue?vue&type=script&lang=js&"
import style0 from "./schoolyearSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports